'use client';
import { CrossSVG, ViewTableSVG } from '@sbercloud/uikit-product-icons';
import { ButtonOutline } from '@snack-uikit/button';

import { useHeaderRightSectionCtx } from '@/hooks/ctx';

import s from './styles.module.scss';

function getIcon(isOpen: boolean) {
  if (isOpen) return CrossSVG;
  return ViewTableSVG;
}

export function Burger() {
  const ctx = useHeaderRightSectionCtx();
  const Icon = getIcon(ctx.isOpenBurgerContent);
  return (
    <ButtonOutline
      size='s'
      appearance='neutral'
      icon={<Icon size={36} onClick={ctx.toggleIsOpenBurgerContent} className={s.burger_wrapper} />}
    />
  );
}
